import { recordsConstants } from '../constants/records.constants';
import { authHeader } from '../helpers/auth-header';
import { client } from './';

const url = '/Request';

let audioCtx;
let audioSource;
let audioBuffer;
let startedAt = 0;
let pausedAt = 0;
let recTimer;
let playbackRate = 1;
const updateInterval = 1000;

export const recordsActions = {
	fetchRecords,
	fetchRecord,
	playRecord,
	fechAndPlay,
	fechAndSave,
	pause,
	resume,
	updateTimer,
	moveTo,
	setPlaybackRate,
}; 

// function moveTo(val) {

// 	return dispatch => {
		
// 		const rn = audioSource;		
// 		if(rn) { dispatch( pause()) };
// 		pausedAt = val;
// 		if(rn) { dispatch( resume()) };
// 	}
// }

function playRecord(record, recId) {
  return dispatch => {
    if (record) {
      let b = Buffer.from(record, "base64");
      let audioData = b.buffer.slice(b.byteOffset, b.byteOffset + b.byteLength);
      
      audioCtx.decodeAudioData(audioData).then( buffer => {
        let duration = 0;
        audioSource = audioCtx.createBufferSource();
        
        if (audioSource.playbackRate) {
          audioSource.playbackRate.value = playbackRate;
        }
        
        audioSource.onended = () => { dispatch(nandleOnEnded()) };
        audioBuffer = buffer;
        audioSource.buffer = audioBuffer;
        duration = audioBuffer.duration;
        
        recTimer && clearInterval(recTimer);
        recTimer = setInterval(() => { dispatch(updateTimer()) }, updateInterval);
        audioSource.connect(audioCtx.destination);
        audioSource.start(0);
        
        dispatch({
          type: recordsConstants.PLAY_RECORD,
          payload: recId,
          recdurt: duration,
        });
      })
      .catch( e => {
        audioSource || stop();
        audioBuffer = null;
        console.log("decodeAudioData Error:");
        console.log(e);
        dispatch({
          type: recordsConstants.DATA_DECODE_ERROR,
          payload: ''+e,
        });
      });
    }
  };
}

function resume() {
  return dispatch => {
    let offset = pausedAt;
    audioSource = audioCtx.createBufferSource();
    
    if (audioSource.playbackRate) {
      audioSource.playbackRate.value = playbackRate;
    }
    
    audioSource.onended = () => { dispatch(nandleOnEnded()) };
    audioSource.connect(audioCtx.destination);
    audioSource.buffer = audioBuffer;
    audioSource.start(0, offset);
    startedAt = audioCtx.currentTime - offset;
    pausedAt = 0;
    recTimer = setInterval(() => { dispatch(updateTimer()) }, updateInterval);
    dispatch({
      type: recordsConstants.RESUME,
    });
  };
}

// function resume() {
// 	return dispatch => {
// 		let offset = pausedAt;
// 		audioSource = audioCtx.createBufferSource();
// 		audioSource.onended = () => { dispatch(nandleOnEnded()) }
// 		audioSource.connect(audioCtx.destination);
// 		audioSource.buffer = audioBuffer;
// 		audioSource.start(0, offset);
// 		startedAt = audioCtx.currentTime - offset;
// 		pausedAt = 0;
// 		recTimer = setInterval(() => { dispatch(updateTimer()) }, updateInterval);
// 		dispatch({
// 			type: recordsConstants.RESUME,
// 		})
// 	}
// }

function moveTo(val) {
  return dispatch => {
    const rn = audioSource;
    if(rn) { dispatch( pause()) };
    pausedAt = val;
    if(rn) { 
      dispatch( resume());
    };
  };
}

function updateTimer(val) {

	return dispatch => {

		val && recTimer && clearInterval(recTimer);

		dispatch({
			type: recordsConstants.SET_RECORD_POS,
			payload: val || audioCtx.currentTime - startedAt,
		})
	}
}

function fechAndSave(opt) {
	return (dispatch, getState) => {	
		dispatch({
			type: recordsConstants.FETCH_RECORD_DOWNLOAD+'_START',
			payload: opt.id,				
		})					
		dispatch({
			type: recordsConstants.FETCH_RECORD_DOWNLOAD,
			recordId: opt.id,
			payload: saveRecord(opt)
				.catch(err=>{console.log(err)}),
		})					
	}
}

function fechAndPlay(opt) {
	return (dispatch, getState) => {
		if (getState().recordsStore.playing) {
			if (audioSource) {
				//audioSource.stop()
				audioSource.disconnect()
				audioSource = null
			}
		}
		audioCtx && audioCtx.close()
		audioCtx = undefined
		audioCtx = new (window.AudioContext || window.webkitAudioContext)()
		startedAt = 0
		pausedAt = 0
		dispatch({
			type: recordsConstants.FETCH_RECORD,
			payload: opt,
		})
		return fetchRecord(opt).then(
			record => dispatch(playRecord(record.data, opt)),
			error => dispatch({
				type: recordsConstants.FETCH_RECORD+'_REJECTED',
				payload: error,
			})
		)
	}
}

async function saveRecord(recInfo) {
	const record = await fetchRecord(recInfo.id)
	if (record && record.data) {
		let data = Buffer.from(record.data, "base64");
		const url = window.URL.createObjectURL(new Blob([data]));
		const link = document.createElement('a');
		link.href = url;
		const ext = recInfo.extension || 'wav'
		link.setAttribute('download', 		
			recInfo.createTime+' '+recInfo.direction+" "+recInfo.phoneNumber+"."+ext); 
		document.body.appendChild(link);
		link.click(); 
	}
}

// function playRecord(record, recId) {
// 	return dispatch => {
// 		if (record) {
// 			let b = Buffer.from(record, "base64");
// 			let audioData = b.buffer.slice(b.byteOffset, b.byteOffset + b.byteLength)
// 			audioCtx.decodeAudioData(audioData).then( buffer => {
// 					let duration = 0;
// 					audioSource = audioCtx.createBufferSource()
// 					audioSource.onended = () => { dispatch(nandleOnEnded()) }
// 					audioBuffer = buffer
// 					audioSource.buffer = audioBuffer
// 					duration = audioBuffer.duration					
// 					recTimer && clearInterval(recTimer)
// 					recTimer = setInterval(() => { dispatch(updateTimer()) }, updateInterval)
// 					audioSource.connect(audioCtx.destination)
// 					audioSource.start(0)
// 					dispatch({
// 						type: recordsConstants.PLAY_RECORD,
// 						payload: recId,
// 						recdurt: duration,
// 					})			
// 				})
// 				.catch( e => {
// 					audioSource || stop()
// 					audioBuffer = null
// 					console.log("decodeAudioData Error:")
// 					console.log(e)
// 					dispatch({
// 						type: recordsConstants.DATA_DECODE_ERROR,
// 						payload: ''+e,
// 					})})
// 		}
// 	}
// }

function stop() {

	clearInterval(recTimer);
	if (audioSource) {
		audioSource.disconnect();
		audioSource.stop(0);
		audioSource = null;
	}
	startedAt = 0;
	pausedAt = 0;

	return dispatch => {
		dispatch({
			type: recordsConstants.STOP,
		})
	}
}


function nandleOnEnded() {
	clearInterval(recTimer)
	if (audioSource) {
		audioSource.disconnect()
		audioSource.stop(0)
		audioSource = null
	}

	audioCtx && audioCtx.close()
	audioCtx = undefined

	startedAt = 0
	pausedAt = 0

	return dispatch => {
		dispatch({
			type: recordsConstants.STOP,
		})
	}
}

function pause() {
	clearInterval(recTimer)
	const elapsed = audioCtx.currentTime - startedAt;
	if (audioSource) {
		audioSource.disconnect();
		audioSource = null;
	}
	startedAt = 0;
	pausedAt = elapsed;
	return dispatch => {
		dispatch({
			type: recordsConstants.PAUSE,
		})
	}
}

function setPlaybackRate(rate) {
  return dispatch => {
    playbackRate = rate;
    
    if (audioSource && audioCtx) {
      if (audioSource.playbackRate) {
        audioSource.playbackRate.value = rate;
      }
    }
    
    dispatch({
      type: recordsConstants.SET_PLAYBACK_RATE,
      payload: rate,
    });
  };
}

function fetchRecords(opt) {
	let rurl = url;
	rurl += '/request_records/' + opt;
	return client.get(rurl, { headers: authHeader() })
}

function fetchRecord(opt) {
	let rurl = url;
	rurl += '/record/' + opt;
	return client.get(rurl, { headers: authHeader() });
}
